import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { setBlogMeta } from "./blogMeta";
import "./blog.css";
import Footer from "../Footer";

const API_URL = `${process.env.React_APP_BACKEND_URL}/api/blog/articles`;

function BlogArticlePage() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const initialArticle =
    window.__BLOG_INITIAL_DATA__?.type === "article" &&
    window.__BLOG_INITIAL_DATA__?.article?.slug === slug
      ? window.__BLOG_INITIAL_DATA__.article
      : null;

  const [article, setArticle] = useState(initialArticle);
  const [loading, setLoading] = useState(!initialArticle);
  const [error, setError] = useState("");

  const handlePostBidClick = () => {
	  if (Cookies.get("id")) {
		window.location.href = "/postbid";
	  } else {
		window.location.href = "/userlandingpage#page-top";
	  }
	};

  useEffect(() => {
    if (initialArticle) return;

    let active = true;
    setLoading(true);
    setError("");

    axios
      .get(`${API_URL}/${encodeURIComponent(slug)}`)
      .then((response) => {
        if (active) setArticle(response.data.article);
      })
      .catch((requestError) => {
        if (active) {
          setError(
            requestError?.response?.status === 404
              ? "המאמר לא נמצא או שאינו מפורסם."
              : "לא ניתן לטעון את המאמר.",
          );
        }
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [slug, initialArticle]);

  useEffect(() => {
    if (!article) return;

    const seoTitle = article.meta_title || article.h1 || article.title;

    setBlogMeta({
      title: seoTitle,
      description: article.meta_description || article.excerpt,

      canonical:
        article.url || `${window.location.origin}/blog/${article.slug}`,

      ogTitle: seoTitle,

      ogDescription:
        article.og_description || article.meta_description || article.excerpt,

      ogImage: article.og_image || article.display_image,

      type: "article",
    });
  }, [article]);

  if (loading) return <main className="blog-state">טוען מאמר...</main>;

  if (error || !article)
    return <main className="blog-state">{error || "המאמר לא נמצא."}</main>;

  return (
    <main dir="rtl">
      <div className="article-page">
        <Link className="article-page__back" to="/blog">
          ← חזרה לכל המאמרים
        </Link>

        <article>
          <header className="article-page__header">
            <h1>{article.h1 || article.title}</h1>

            {article.excerpt && <p>{article.excerpt}</p>}

            {article.published_at && (
              <time dateTime={article.published_at}>
                {new Date(article.published_at).toLocaleDateString("he-IL")}
              </time>
            )}
          </header>

          {article.display_image && (
            <div className="article-page__image-frame">
              <img
                className="article-page__image"
                src={article.display_image}
                alt={article.title}
                loading="eager"
                decoding="async"
                style={{
                  display: "block",
                  width: "auto",
                  maxWidth: "100%",
                  height: "auto",
                  maxHeight: "min(72vh, 760px)",
                  objectFit: "contain",
                  objectPosition: "center top",
                }}
              />
            </div>
          )}

          <div
            className="article-page__content"
            dangerouslySetInnerHTML={{
              __html: article.content || article.description,
            }}
          />

          <section className="article-page__cta">
            <h2 className="article-page__cta-title">
              במקום לחפש בעלי מקצוע - תנו להם להגיע אליכם.
            </h2>

            <p className="article-page__cta-description">
              פרסמו את העבודה וקבלו הצעות מבעלי מקצוע באזורכם.
            </p>

            <div className="article-page__cta-actions">
              <button
                type="button"
                className="article-page__cta-primary"
                onClick={handlePostBidClick}
              >
                פרסמו מכרז בחינם
              </button>

				<a
				  className="article-page__cta-secondary"
				  href="/proflandingpage"
				>
				  הירשמו כבעלי מקצוע
				</a>
            </div>
          </section>
        </article>
      </div>

      <Footer />
    </main>
  );
}

export default BlogArticlePage;